module.exports = __webpack_public_path__ + "img/Chat.917e3eb7.png";